var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInvitation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-invitation_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-invitation_svg__st0{fill:#050505}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-invitation_svg__st0",
    d: "M20.4 6L16 1.6c-.4-.4-.9-.6-1.4-.6H5c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.4c0-.5-.2-1-.6-1.4zM15 3.4L18.6 7H15V3.4zM19 21H5V3h8v5c0 .5.5 1 1 1h5v12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-invitation_svg__st0",
    d: "M15.5 15c0 .5-.5 1-1 1H13v1.5c0 .5-.5 1-1 1s-1-.5-1-1V16H9.5c-.5 0-1-.5-1-1s.5-1 1-1H11v-1.5c0-.5.5-1 1-1s1 .5 1 1V14h1.5c.5 0 1 .4 1 1z"
  })));
}

export default SvgIconInvitation;